/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Carrier_Name_ViettelpostInputs */

const vi_carrier_carrier_name_viettelpost = /** @type {(inputs: Carrier_Carrier_Name_ViettelpostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viettel Post`)
};

/**

* @param {Carrier_Carrier_Name_ViettelpostInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_carrier_name_viettelpost = /** @type {((inputs?: Carrier_Carrier_Name_ViettelpostInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Carrier_Name_ViettelpostInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_carrier_name_viettelpost(inputs)
});